<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">近1500支队伍、6000名开发者齐聚，第三届Light技术公益创造营收官</div>
      <div class="news-date">2023年5月15日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>在很多老年人看来，融入数字生活并不容易，经常误点广告、不时接到诈骗电话、不会操作智能手机……但有些老年人并不担心这些，“误点了付款，有人会打电话过来，提醒我不要被骗了。”一位老人放心地进行着“网上冲浪”。而这，是源于Light·技术公益创造营中玄钺安全的精准反诈分析模型。</p>
        <p>
          <span class="mark-text highlight">2023年5月13日，由腾讯公益慈善基金会、中国互联网发展基金会主办的第三届Light·技术公益创造营项目路演在北京举办。</span>
          众多优秀公益队伍聚焦数字时代下
          <span class="mark-text highlight">“未成年人心理健康”“老年人用网安全”“生物多样性保护”三大议题，</span>
          从关注泛人群，到关注特定人群的具体需求，紧贴公益领域进化脚步，践行人人可公益理念，为公益慈善事业健康发展注入驱动力和变革力。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news34.png"/>
          </div>
        </div>
        <br>

        <div class="news-content-mark">
          <h2>1. 人人可公益，技术公益创新方案亮点不断</h2>
        </div>
        <p>
          新生儿黄疸AI图像识别、AI寻人、AI物种保护……在“AI+公益”的浪潮中，Light·技术公益创造营不断推动云上AI“技术价值外溢”，着力解决越来越多领域的民生痛点，成为以技术助力公益的先锋力量。
          <span class="mark-text highlight">举办三届以来，已经吸引超过3600支队伍、18000名开发者参加，是目前国内最具影响力的技术公益平台之一。</span>
        </p>
        <p>
          <span class="mark-text highlight">第三届Light共吸引1429支队伍报名参与公益提案，最终有136支队伍入围。</span>
          路演现场，三大领域的入围队伍以更专业、更热情的态度，展示技术公益的个性化、多元化解决方案。经过专业评委现场评审，创造营最终获奖名单出炉：“未成年人心理健康”赛道的中国家庭教育学会、深圳市镜像科技有限公司、麦芽心理，“老年人用网安全”赛道的山东犀盐数据科技有限公司、六便士小组、独立老人队，“生物多样性保护”赛道的爱动超越人工智能、阿尔泰山自然保护、淄博市蓝色蔚来社会创新发展中心等众多队伍荣获优秀项目奖；其中，山东犀盐数据科技有限公司凭借“老年人用网安全”的创新探索，荣获公益创新项目奖。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news34/news34_1.jpeg"/>
          </div>
        </div>
        <p>在老人用网安全领域，山东犀盐数据玄钺安全实验室基于腾讯云AI建设高精准反诈分析模型，实现智能识别疑似诈骗电话、短信、APP风险，并对风险行为预警及提示，有效提升事前预警、事中干预、事后线索提供的防诈骗能力，封堵老年人群体在网络世界中遇到的诈骗行为。六便士队的“绿盾守护者”项目通过先扫码识别、再语音提醒、最后看实际受骗案例一连串体系化的动作，帮助更多老年人形成防骗意识闭环。在生物多样性保护领域，淄博蓝色蔚来团队的植樾—中国古树地图项目运用腾讯云自然语言处理，将个性化的信息标准化，让每一棵古树拥有自己的“身份证”，从而更好地帮助古树名木保护与传承的单位与个人搭建古树数据地图，进一步强化古树保护能力。</p>
        <p>山东犀盐数据代表表示，在人人可公益理念的支撑下，未来将以技术帮助更多老年人用网安全。淄博蓝色蔚来团队代表也表示，在用AI解决社会问题的过程中，将与更多伙伴共同思考公益的可持续新模式，助推公益更开放、更有活力。</p>
        <br>

        <div class="news-content-mark">
          <h2>2. 开放、共创、共享，构筑公益数字化的价值桥梁</h2>
        </div>
        <p>
          <span class="mark-text highlight">满足真正的社会需求，是技术公益创新的根本动力。</span>
          依托腾讯云智能开放的超过300多个AI原子能力，参与团队洞察特殊群体普遍、深层的急难愁盼问题，并根据自身的创意、经验创想公益项目，群策群力创变出更具针对性的多元化公益落地产品，提升公益慈善的效能，搭建起一座座公益数字化的价值桥梁。
        </p>
        <p>中国互联网发展基金会副秘书长彭锋表示，基金会联合腾讯启动数字公益创新空间项目，一方面从内部推动数字化转型，实现了公益项目全流程数字化、透明化；另一方面，为落地公益项目提供项目咨询、孵化、共享办公，以及团队培育等支持，逐步推动形成数字公益生态圈。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news34/news34_2.jpeg"/>
            <div class="image-caption">彭锋 中国互联网发展基金会副秘书长</div>
          </div>
        </div>
        <p>
          <span class="mark-text highlight">腾讯云副总裁、腾讯云智能负责人吴运声表示，腾讯云智能一直致力于为各行各业的产业用户提供多元化、低成本、低门槛、高可用的人工智能产品和解决方案，</span>
          基于此，全社会的开发者不断探索利用科技的力量来解决社会问题，促使越来越多优秀、充满想象空间的公益项目落地，更好地践行了可持续社会价值创新。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news34/news34_3.jpeg"/>
            <div class="image-caption">吴运声 腾讯云副总裁、腾讯云智能负责人</div>
          </div>
        </div>
        <p>另外，腾讯还通过专业的质量云平台WeTest，为复选项目提供WeTest一站式质量服务；并提供底层开源操作系统OpenCloudOS底座生态支持，使得参与团队便捷地将AIGC、图像识别、语音生成等多领域新技术应用到技术公益落地的过程中，持续激发公益人士探索数字技术应用于公益场景可行路径的能动性。</p>
        <p>
          本届Light·技术公益创造营的“公益传播大使”，著名演员黄晓明指出，
          <span class="mark-text highlight">公益是社会的温度计，科技是创新的动力，两者深度结合，用智慧的火花点亮希望之光，助推无数需要帮助的人更好地融入数字时代。</span>
          最后，他表示，人人公益就是一颗颗爱心汇聚而成的温暖海洋，希望更多人共同行动起来，用爱心和科技的力量，为推动公益事业发展做出更多贡献。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news34/news34_4.png"/>
            <div class="image-caption">黄晓明 Light·技术公益创造营传播大使</div>
          </div>
        </div>
        <p>除了低门槛的技术应用，腾讯还打通了公益共创生态。第三届Light与腾讯技术公益创投计划深度连接，所有相关入选项目均可获得推优“直通车”资格。同时，还为公益实干组团队提供技术共建和专业志愿者招募，为有需求的公益创想优秀团队牵线公益组织，全方位引导共建共治共享的公益共创新模式。</p>
        <br>

        <div class="news-content-mark">
          <h2>3. 坚守“科技向善”愿景，构建不断创变可持续技术公益</h2>
        </div>
        <p>
          在技术公益的前行探索上，腾讯始终秉承长期主义构建向善传播和落地平台。
          <span class="mark-text highlight">从第一届挑战赛的“‘哇！白海豚’助力野生动植物保护”、“‘悦聆’关爱空巢老人”，到第二届挑战赛的“蒙新河狸科技赋能”“‘语言海洋泡泡’帮助山区孩子讲好普通话”，再到如今的第三届共创营，腾讯携手众多生态伙伴、社会力量构建不断创变的可持续公益模式，深度践行科技向善的理念，努力实现技术与公益的有益互动，为公益可持续发展带来更多可能。</span>
        </p>
        <p>其中，腾讯一方面引导参与团队用AI去解决社会问题，着力改善诸多公益场景难题；另一方面，则努力实现公益产品覆盖区域最大化、技术公益模式的可持续。从策划阶段开始，腾讯就通过链接政府、NGO公益组织、公益志愿者等多方资源，推动技术公益项目精准触达更多人群并落地实践，使其能够应用范围更广，效果更显性化，助力开启解决社会问题的“共益时代”。</p>
        <p>未来，腾讯将以Light·技术公益创造营等技术公益平台的可持续发展为契机，以技术创新拓展公益的宽度和广度，并持续探索低门槛、多场景的共创公益生态可行路径，让更多社会公益议题走进大众视野的同时，持续激发更多人群向善向美的正能量，打开“人人公益”全新的想象空间。</p>

      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News29',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News34.vue